import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=33cffaf9&"
import script from "./ConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports